import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/compilation-seed-demand`
const endpoints = {
    hqListing: () => `${RESOURCE_ENDPOINT}/hq-listing`,
    regionListing: () => `${RESOURCE_ENDPOINT}/region-listing`,
    districtListing: () => `${RESOURCE_ENDPOINT}/district-listing`,
    upazilaListing: () => `${RESOURCE_ENDPOINT}/upazila-listing`,
    unionListing: () => `${RESOURCE_ENDPOINT}/union-listing`,
    getSummeryInfo: () => `${RESOURCE_ENDPOINT}/summary-info`,
    getSummeryListing: () => `${RESOURCE_ENDPOINT}/summary-listing`,
    lock: () => `${RESOURCE_ENDPOINT}/lock`,
}

export default class CompilationSeedDemandApi {
       public hqListing = (params = {}, headers = {}): AxiosPromise<any> => {
            const url = endpoints.hqListing();
            return HttpService.get(url, params, headers);
        }
    public regionListing = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.regionListing();
        return HttpService.get(url, params, headers);
    }

    public districtListing = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.districtListing();
        return HttpService.get(url, params, headers);
    }

    public upazilaListing = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.upazilaListing();
        return HttpService.get(url, params, headers);
    }

    public unionListing = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.unionListing();
        return HttpService.get(url, params, headers);
    }

    public getSummeryInfo = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getSummeryInfo();
        return HttpService.post(url, payload, params, headers);
    }

    public getSummeryListing = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getSummeryListing();
        return HttpService.post(url, payload, params, headers);
    }

    public lock = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.lock();
        return HttpService.post(url, payload, params, headers);
    }
}
